import { clientContactsListingRoutes } from './features/client-contact-listing/client-contacts-listing.routes';
import { clientContactRoutes } from './features/client-contact-details/client-contact-details.routes';
export const clientContactsRoutes = [
  {
    path: '/client-contacts',
    name: 'client-contacts',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "client-contacts" */ './ClientContacts.vue'),
    children: [...clientContactsListingRoutes, ...clientContactRoutes]
  }
];
